export const Modal = ({ children }) => {
	return children;
};
